// src/App.tsx

import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

import TelemetryProvider from "./telemetry/TelemetryProvider";
import { useEffect } from "react";
import websocketService from "./services/websocketService";
import { Toaster } from "sonner";

import { initializeActivityTracking, clearSession } from "./utils/sessionManager";

import GlobalAskKiki from "./components/AskKikiWidget/GlobalAskKiki";

function App() {

  useEffect(() => {
    // Initialize standard user activity tracking
    const cleanupTracking = initializeActivityTracking(false, () => {
      clearSession(false);
    });

    const username = localStorage.getItem("username");

    if (username) {
      websocketService.connect(username);
    }

    return () => {
      websocketService.disconnect();
      cleanupTracking();
    };
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={__BASE_PATH__}>
          <TelemetryProvider>
            <AppRoutes />
            <Toaster position="top-right" richColors />
            <GlobalAskKiki />
          </TelemetryProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </I18nextProvider>
  );
}

export default App;